<template>
  <div class="bg_scroll">
    <base-top-title :title="title" back class="fixTitle">
      <span class="searchInput">
        <el-input
          type="text"
          placeholder="请输入关键字查询相关题目"
          v-model="keyVal"
          @keyup.native="throttle"
          @clear="throttle"
          clearable
          ref="input"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </span>
      <el-button
        type="default"
        class="btn__primary"
        @click="invalidVisible = true"
      >
        作废
      </el-button>
      <el-button
        type="default"
        class="btn__primary"
        v-show="!isNoAnswer"
        @click="submitAnswerHandler('保存成功')"
        :loading="saveLoading"
      >
        保存
      </el-button>
      <el-button
        type="zebra-primary"
        @click="submitBtn"
        :loading="subBtnLoading"
        >提交</el-button
      >
    </base-top-title>
    <div class="content online">
      <base-info :task="task" :auditor="auditor"> </base-info>
      <el-row class="lineBg"></el-row>
      <div
        class="online_wrap online_wrap_content"
        element-loading-text="拼命加载中"
        v-loading="changeLoading || allAnswerLoading"
        element-loading-spinner="el-icon-loading"
      >
        <base-title :title="title_content"> </base-title>
        <el-row class="question_wrap" v-show="!isNoAnswer">
          <question-list
            :questions="info.list"
            @pick="pickHandler"
            @saveSolo="saveSolo"
            ref="AllQues"
          ></question-list>
        </el-row>
        <el-row v-show="isNoAnswer" class="isNoAnswer">
          暂无数据
        </el-row>
        <check-result
          :subVisible="subVisible"
          :task="task"
          ref="CheckResult"
          @submitQuestion="submitQuestion"
          @closeDialog="subVisible = false"
        >
        </check-result>
        <invalid-dailog
          :invalidVisible="invalidVisible"
          :taskId="task_id"
          :invalidType="invalidType"
          @defalut="invalidVisible = false"
        >
        </invalid-dailog>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInfo from './pageComponents/BaseInfo'
import CheckResult from './pageComponents/CheckResult'
import InvalidDailog from './pageComponents/InvalidDailog'
import QuestionList from './pageComponents/QuestionList'
import { formatData } from './constant/method'
import { mapGetters } from 'vuex'
import { Loading } from 'element-ui'
import { mixin } from '@/app/index/mixin'
export default {
  name: 'qestionIndex',
  components: {
    BaseInfo,
    CheckResult,
    InvalidDailog,
    QuestionList
  },
  mixins: [mixin],
  computed: {
    ...mapGetters(['infomationList', 'userInfo'])
  },
  watch: {
    infomationList (newVal, oldVal) {
      // console.log('new', newVal)
      this.projectId = newVal
    }
  },
  data () {
    return {
      title: '在线复核',
      invalidType: 'online',
      subVisible: false, // 提交弹框展示
      invalidVisible: false, // 作废弹框
      isNoAnswer: false, // 没有答卷展示暂无数据
      saveLoading: false, // 保存loading
      subLoading: false, // 提交loading
      subBtnLoading: false, // 外部提交按钮的loading
      changeLoading: false, // 修改loading
      allAnswerLoading: false, // 页面初加载所有维度的题loading
      title_content: '问卷内容',
      task_id: Number(this.$route.query.taskId),
      info: {
        list: [] // 题目信息数组
      },
      submitInfo: {
        task_id: Number(this.$route.query.taskId), // 任务id
        question_all: {}
      },
      task: {}, // 详情相关参数
      auditor: [], // 详情相关参数
      question_all: {}, // 保存时相关维度下的所有题目
      submit_question_all: {}, // 提交时所有维度下的题目
      isSaved: false, // 是否保存操作
      keyVal: '',
      status: true, // 截流标志符
      timer: '', // 定时保存
      hasCheck: false, // 判断是否有未审核的审核点（true为审核点未填写, fasle为填写请求保存接口）
      hasNextTick: false, // 判断是否有未审核的审核点
      projectId: '',
      prevList: [], // 保存的截取数组
      loadingInstance: ''
    }
  },

  methods: {
    submitBtn () {
      // 弹框外提交
      let isSubmit = true
      if (this.keyVal) {
        this.keyVal = ''
        this.hasNextTick = true
        this.getAllData('')
      } else {
        this.hasCheck = this.checkAllData(isSubmit)
      }
      if (!this.hasCheck) {
        this.submitLogic()
      }
    },
    async submitLogic () {
      // 提交时校验逻辑
      this.stopTime()
      let allData = formatData(this.question_all)
      this.submitInfo.question_all = allData
      this.subBtnLoading = true
      let { data } = await this.axios
        .post('/home/auditor/task/judgeRecheckAnswer', {
          task_id: this.task_id,
          project: this.projectId
        })
        .catch(() => {
          this.startTime()
        })
      let { success, results, rows } = data
      if (success) {
        if (results.code === 0) {
          this.subVisible = true
        } else if (results.code === 1) {
          this.setMessage(rows)
        }
      } else {
        this.$message({
          duration: 5000,
          message: results.msg
        })
      }
      this.startTime()
      this.subBtnLoading = false
    },
    // closeDialog () { // 关闭提交
    //   this.subVisible = false
    // },
    async getAllData (keyword) {
      // 获取全部纬度下的问题
      this.allAnswerLoading = true
      let { data } = await this.axios.post(
        '/home/questionnaire/question/list',
        { task_id: this.task_id, keyword: keyword, project: this.projectId }
      )
      const { success, results, rows = [] } = data
      if (success) {
        if (rows.length) {
          this.isNoAnswer = false
          this.info.list = rows
          this.hasNextTick &&
            this.$nextTick(() => {
              this.hasCheck = this.checkAllData()
            })
        } else {
          this.isNoAnswer = true
        }
        this.allAnswerLoading = false
        this.startTime()
      } else {
        this.$message(results.msg)
      }
    },
    setMessage (rows) {
      let reason_logic_type_str = ''
      let reasonStr = []
      let result_logic_type_str = ''
      let resultStr = []
      let reason_li = ''
      let result_li = ''
      rows.length &&
        rows.map((item, index) => {
          reason_logic_type_str = item.condition_arr.logic_type_str
          reasonStr = item.condition_arr.judge_text_str_arr
          result_logic_type_str = item.conclusion_arr.logic_type_str
          resultStr = item.conclusion_arr.judge_text_str_arr
        })
      reasonStr.length &&
        reasonStr.map((reason_item, index) => {
          reason_li += `<li>${reason_item} <span>${reason_logic_type_str}</span><li>`
        })
      resultStr.length &&
        resultStr.map((result_item, index) => {
          result_li += `<li>${result_item} <span>${result_logic_type_str}</span><li>`
        })
      this.$message({
        dangerouslyUseHTMLString: true,
        message:
          '<ul class="tip_box">' +
          reason_li +
          '<li>则</li>' +
          result_li +
          `</ul>`,
        duration: 6000
      })
    },
    async submitAnswerHandler (message) {
      // 保存更改操作
      this.saveLoading = true
      this.stopTime()
      let allData = formatData(this.question_all)
      this.submitInfo.question_all = allData
      let { data } = await this.axios
        .post('/home/auditor/task/submitAnswer', {
          ...this.submitInfo,
          project: this.projectId
        })
        .catch(() => {
          this.startTime()
        })
      let { success, results, rows } = data
      if (success) {
        this.isSaved = true
        if (results.code === 0) {
          message && this.$message(message)
        } else if (results.code === 1) {
          this.setMessage(rows)
        }
      } else {
        this.$message({
          duration: 6000,
          message: results.msg
        })
      }
      this.startTime()
      this.saveLoading = false
    },
    checkAllData (isSubmit) {
      let that = this
      let isNull = false
      let firstErrorId = ''
      this.$refs.AllQues.$refs.quesItem.forEach(item => {
        item.checkData(isSubmit)
      })
      this.$refs.AllQues.$refs.quesItem.forEach(item => {
        if (item.errShow && !isNull) {
          isNull = true
          firstErrorId = item.params.question_id
          that.$nextTick(() => {
            document.querySelector(`.Qitem_${firstErrorId}`).scrollIntoView({
              behavior: 'smooth'
            })
          })
          return that.$message(`请填写相关内容！`)
        }
      })
      this.info.list.map(item => {
        if (
          item.check.length &&
          !item.check[0].data_datetime &&
          item.is_kaocha === 1
        ) {
          if (!isNull) {
            that.$message(`${item.q_number}资料时间点未填写！`)
            isNull = true
            that.$nextTick(() => {
              document
                .querySelector(`.Qitem_${item.question_id}`)
                .scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                })
            })
          }
        }
      })
      return isNull
    },
    async submitQuestion (val) {
      // 弹框内提交问卷
      let { data } = await this.axios.post(
        '/home/auditor/task/recheckDoneTask',
        { task_id: this.task_id, remark: val, project: this.projectId }
      )
      const { success, results } = data
      if (success) {
        this.$message('提交成功！')
        this.$router.push({ path: '/check/schedule' })
      } else {
        this.$message(results.msg)
      }
      this.subVisible = false
      this.$refs.CheckResult.defaultBtn()
    },
    pickHandler (data) {
      // 收集所有改变之后的题
      this.question_all[data.question_id] = data
      this.submit_question_all[data.question_id] = data
    },
    async getDetail () {
      // 获取审核详情的基本信息
      let { data } = await this.axios.get(
        '/home/auditor/task/detailUserQuestionnaire',
        {
          task_id: this.task_id,
          project: this.projectId
        }
      ) // 23
      let { rows, success } = data
      if (success) {
        this.task = rows.task || {}
        this.auditor = rows.auditor || []
      }
    },
    noAnswer () {
      this.isNoAnswer = true
    },
    search () {
      this.getAllData(this.keyVal)
    },
    throttle () {
      let that = this
      if (!this.status) return
      this.status = false
      setTimeout(() => {
        that.search()
        that.status = true
      }, 1000)
    },
    stopTime () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startTime () {
      this.stopTime()
      this.timer = setInterval(() => {
        this.submitAnswerHandler()
      }, 600000)
    },
    saveSolo (from, question_id, option_id, isItem = false) {
      let that = this
      if (!isItem) {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          background: 'rgba(0, 0, 0, 0)',
          text: '拼命加载中'
        })
      }
      let queryData = this.handleData(from)
      let question_all = queryData
      this.axios
        .post('/home/auditor/task/submitAnswer', {
          question_all: question_all,
          project: this.projectId,
          task_id: this.task_id
        })
        .then(({ data }) => {
          let { success, results, rows } = data
          if (success) {
            if (results.code === 0) {
              if (!isItem && (from.q_category === 3 || from.q_category === 5)) {
                this.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  this.loadingInstance.close()
                })
              }
              if (
                (from.q_category === 1 && !isItem) ||
                (from.q_category === 2 && !isItem) ||
                (from.q_category === 4 && !isItem)
              ) {
                // 只有单选/多选/下拉三种提醒触发逻辑更新，排除掉其他题型和时间点，后者只进行保存操作
                that.setNewQuestion(question_id, option_id)
              }
            } else if (results.code === 1) {
              this.setMessage(rows)
              this.$nextTick(() => {
                // 以服务的方式调用的 Loading 需要异步关闭
                this.loadingInstance.close()
              })
            }
          } else {
            this.$message(results.msg)
            this.$nextTick(() => {
              // 以服务的方式调用的 Loading 需要异步关闭
              this.loadingInstance.close()
            })
          }
        })
    },
    setNewQuestion (question_id, option_id) {
      // 更改某个题后重新
      let that = this
      this.keyVal = ''
      this.axios
        .post('/home/questionnaire/question/list', {
          task_id: this.task_id,
          keyword: '',
          option_id: option_id,
          question_id: question_id,
          project: this.projectId
        })
        .then(({ data }) => {
          let { success, rows } = data
          if (success) {
            console.log('ros', typeof rows, rows.length, typeof [])
            // this.info.list &&
            //   this.info.list.map((item, index) => {
            //     if (item.id === question_id) {
            //       let newArr = rows || [];
            //       that.info.list = [];
            //       newArr.map((item, index) => {
            //         this.$set(that.info.list, index, item);
            //       });
            //     }
            //   });
            that.info = {}
            setTimeout(() => {
              this.info = Object.assign({}, this.info, { list: rows })
              this.$nextTick(() => {
                document.querySelector(`.Qitem_${question_id}`).scrollIntoView({
                  behavior: 'smooth'
                })
              })
            }, 0)
          }
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            this.loadingInstance.close()
          })
        })
    },
    handleData (data) {
      this.info.list.map((item, index) => {
        if (item.question_id === data.question_id) {
          this.prevList = this.info.list.slice(0, index + 1)
        }
      })
      let queryData = []
      this.prevList.map(item => {
        queryData.push(this.question_all[item.question_id])
      })
      queryData = queryData.filter(item => {
        if (item.q_category === 3) {
          return item.q_answer_info !== ''
        } else if (item.q_category === 2) {
          return item.checkboxArr.length !== 0
        } else if (item.q_category === 5) {
          return item.cascaderVal.length !== 0
        } else {
          return item.q_option_id !== ''
        }
      })
      return formatData(queryData)
    }
  },
  deactivated () {
    this.isNoAnswer = false
    this.task = {}
    this.auditor = []
    this.question_all = {}
    this.submit_question_all = {}
    this.isSaved = false
    this.saveLoading = false
    this.subLoading = false
    this.subVisible = false
    this.info.list = []
    this.keyVal = ''
    this.submitInfo.task_id = ''
    this.projectId = ''
    this.stopTime()
  },
  activated () {
    this.submitInfo = {
      task_id: Number(this.$route.query.taskId), // 任务id
      question_all: {}
    }
    this.task_id = Number(this.$route.query.taskId)
    this.projectId = this.infomationList
    this.question_all = {}
    this.getAllData()
    this.getDetail()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'schedule') {
      if (!to.meta.keepAlive) {
        to.meta.keepAlive = true
      }
      this.$destroy()
    }
    next()
  },
  destroyed () {
    this.stopTime()
  }
}
</script>

<style lang="scss" scoped>
.bg_scroll {
  overflow: scroll;
}
.fixTitle {
  position: absolute;
  z-index: 999;
}
.content {
  padding-top: 76px;
}
.online {
  &_wrap {
    background: #fff;
  }
}
.isNoAnswer {
  height: 300px;
  text-align: center;
  padding-top: 10%;
  color: #888;
}
.searchInput {
  float: left;
  width: 250px;
  margin-right: 30px;
}
.el-main {
  background: #fff;
}
.lineBg {
  background: #f7f9fc;
  height: 24px;
}
</style>
